import React, { FC } from "react";
import injectSheet from "react-jss";

interface Props {
  classes?: any;
  className?: string;
  value: string | number;
}
import styleSheet from "./styles";

/*
    This will take in a value and apply an ellipsis class to it.  
    This will truncate the value.
    Examples usage:
        ProfileHeader.tsx
        List.tsx
*/
const Ellipsis: FC<Props> = ({ classes, className = "", value = "" }) => (
  <label
    aria-label={value.toLocaleString()}
    className={`${classes.ellipsis} ${className}`}
  >
    {value}
  </label>
);

export default injectSheet(styleSheet)(Ellipsis);
